import { useEffect } from 'react';
import { buildPurchaseAnalyticsPayload, trackGaPurchase } from '../services/gaEvents';
import { trackPurchase } from '../services/metaTracking';

const PADDLE_PAYMENT_SUCCESS_EVENT = 'paddle-payment-success';
// Reports completed Paddle checkouts (overlay and hosted /pay) to GA4 and
// Meta. It only listens to the event paddleService already dispatches; the
// Paddle webhook and billing receipts remain the record of revenue.
// GA4 is gated on analytics consent inside gaEvents; Meta's trackPurchase is
// gated on advertising consent inside metaTracking. Email, user id and queue
// fingerprints from the event detail are never forwarded.
// Nothing is written to the device here: a repeated dispatch is deduped by
// GA4's own post-consent session flag and transaction_id, and by Meta's
// event_id, so this bridge needs no storage of its own (no pre-consent write).
const PurchaseAnalyticsBridge = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handlePaymentSuccess = (event) => {
      try {
        const purchase = buildPurchaseAnalyticsPayload(event?.detail || {});
        if (!purchase) return;

        trackGaPurchase(purchase);
        // Meta Purchase needs a real amount; a zero value would distort ROAS.
        if (purchase.value === null) return;
        trackPurchase({
          transactionId: purchase.transactionId,
          packageId: purchase.packageId,
          packageType: purchase.packageType,
          billingPeriod: purchase.billingPeriod,
          price: purchase.unitPrice,
          value: purchase.value,
          quantity: purchase.quantity,
          credits: purchase.credits ?? undefined,
          currency: purchase.currency,
          eventId: `purchase_${purchase.transactionId}`
        });
      } catch {
        // Analytics must never interfere with checkout completion.
      }
    };

    window.addEventListener(PADDLE_PAYMENT_SUCCESS_EVENT, handlePaymentSuccess);
    return () => {
      window.removeEventListener(PADDLE_PAYMENT_SUCCESS_EVENT, handlePaymentSuccess);
    };
  }, []);

  return null;
};

export default PurchaseAnalyticsBridge;
